import {
  axiosApiInstance as Axios,
  axiosApiInstanceFormData as AxiosFormData,
} from '../utils/serviceUtils';

const BASE_URL_OPERATION = `${process.env.REACT_APP_BACKEND_API_URL}operation`;
const BASE_URL_NOTIFICATION = `${process.env.REACT_APP_BACKEND_API_URL}notification`;

export const getOperationsAxios = () => Axios.get(`${BASE_URL_OPERATION}/operations`);
export const getCompaniesAxios = () => Axios.get(`${BASE_URL_OPERATION}/companies`);
export const getStepsAxios = (idoperation) =>
  Axios.get(`${BASE_URL_OPERATION}/${idoperation}/steps`);
export const getStepAxios = (idstep) => Axios.get(`${BASE_URL_OPERATION}/${idstep}/step`);
export const getActivitiesAxios = (idstep) =>
  Axios.get(`${BASE_URL_OPERATION}/${idstep}/activities`);
export const getCommentsAxios = (idactivity) =>
  Axios.get(`${BASE_URL_OPERATION}/${idactivity}/comments`);
export const getCommentContainersAxios = (idoperation) =>
  Axios.get(`${BASE_URL_OPERATION}/${idoperation}/comments_container`);
export const getFilesAxios = (idcomment) => Axios.get(`${BASE_URL_OPERATION}/${idcomment}/files`);
export const getFilesContainerAxios = (idcomment) =>
  Axios.get(`${BASE_URL_OPERATION}/${idcomment}/files_container`);
export const getOperationUpdateAxios = (idoperation) =>
  Axios.get(`${BASE_URL_OPERATION}/${idoperation}/operation`);
export const getBusinessLineAxios = () => Axios.get(`${BASE_URL_OPERATION}/businessline`);
export const getTeamAndClientsAxios = () => Axios.get(`${BASE_URL_OPERATION}/clients_and_analyst`);
export const getContainersAxios = (idoperation) =>
  Axios.get(`${BASE_URL_OPERATION}/${idoperation}/containers`);
export const getAnalystsAxios = () => Axios.get(`${BASE_URL_OPERATION}/analysts`);
export const getAllCompaniesAxios = () => Axios.get(`${BASE_URL_OPERATION}/all_companies`);
export const getUsersAxios = () => Axios.get(`${BASE_URL_OPERATION}/users`);
export const getExternalUsersAxios = () => Axios.get(`${BASE_URL_OPERATION}/external_users`);
export const inactiveUserAxios = (data) => Axios.post(`${BASE_URL_OPERATION}/inactive_user`, data);
export const getBusinesslinesAxios = () => Axios.get(`${BASE_URL_OPERATION}/businesslines`);
export const getRolesAxios = () => Axios.get(`${BASE_URL_OPERATION}/roles`);

export const postOperationByDoskyAxios = (data) =>
  Axios.post(`${BASE_URL_OPERATION}/operationsByDOsky`, data);
export const postCreateCommentAxios = (data) =>
  Axios.post(`${BASE_URL_OPERATION}/create-comment`, data);
export const presignedRes = (data) =>
  Axios.post(`${BASE_URL_OPERATION}/generate-presigned-url`, data);
export const postCreateContaienrCommentAxios = (data) =>
  Axios.post(`${BASE_URL_OPERATION}/create-comment-container`, data);
export const postChangeStatusAxios = (data, idoperation) =>
  Axios.post(`${BASE_URL_OPERATION}/change-status-operation/${idoperation}`, data);
export const postCreateOperationAxios = (data) =>
  Axios.post(`${BASE_URL_OPERATION}/create-operation`, data);
export const postUpdateOperationAxios = (data, idoperation) =>
  Axios.post(`${BASE_URL_OPERATION}/update-operation/${idoperation}`, data);
export const postUpdateActivityAxios = (data) =>
  Axios.post(`${BASE_URL_OPERATION}/update_activity`, data);
export const postSetEndDateActivityAxios = (data) =>
  Axios.post(`${BASE_URL_OPERATION}/set_end_date`, data);

export const changeRoleAxios = (data) => Axios.post(`${BASE_URL_OPERATION}/change_role`, data);
export const createBusinessLineAxios = (data) =>
  Axios.post(`${BASE_URL_OPERATION}/create_businessline`, data);
export const removeBusinessLineAxios = (data) =>
  Axios.post(`${BASE_URL_OPERATION}/remove_businessline`, data);
export const addCompanyToUserAxios = (data) =>
  Axios.post(`${BASE_URL_OPERATION}/add_company_to_user`, data);
export const removeCompanyToUserAxios = (data) =>
  Axios.post(`${BASE_URL_OPERATION}/remove_company_to_user`, data);

export const downloadFileAxios = (idfile) =>
  Axios.get(`${BASE_URL_OPERATION}/download-file/${idfile}`);
export const downloadFileContainerAxios = (idfile) =>
  Axios.get(`${BASE_URL_OPERATION}/download-file-container/${idfile}`);
export const sendMailAxios = (data) =>
  AxiosFormData.post(`${BASE_URL_NOTIFICATION}/sendMail`, data);
export const sendMailContainerAxios = (data) =>
  AxiosFormData.post(`${BASE_URL_NOTIFICATION}/sendMailContainer`, data);
export const resendMailAxios = (data) => Axios.post(`${BASE_URL_NOTIFICATION}/resendMail`, data);
export const resendMailContainerAxios = (data) =>
  Axios.post(`${BASE_URL_NOTIFICATION}/resendMailContainer`, data);
export const getEmailsAxios = (operationId) =>
  Axios.post(`${BASE_URL_NOTIFICATION}/getEmails/${operationId}`);

export const getOperationsdraftAxios = () => Axios.get(`${BASE_URL_OPERATION}/getOperation-draft`);
export const getOperationdraftbyidAxios = (operationid) =>
  Axios.get(`${BASE_URL_OPERATION}/operation-draft-Id/${operationid}`);
export const saveOperationDraftAxios = (data) =>
  Axios.put(`${BASE_URL_OPERATION}/operation-draft`, data);
export const deleteOperationDraftAxios = (operationid) =>
  Axios.delete(`${BASE_URL_OPERATION}/delete-operationdraft/${operationid}`);

export const getUrlQuickSightAxios = (dashboardId) =>
  Axios.post(`${BASE_URL_OPERATION}/getUrlQuickSight`, { dashboardId });

export const getExternalAnalystAxios = (nit) =>
  Axios.get(`${BASE_URL_OPERATION}/external_analyst?nit=${nit}`);

export const postChangeResponsableOperationAxios = (data) =>
  Axios.post(`${BASE_URL_OPERATION}/change-responsible`, data);

export const getUsersResponsityAxios = (businessline_id, company_id) =>
  Axios.get(
    `${BASE_URL_OPERATION}/get-users-by-businessline-company/${businessline_id}/${company_id}`,
  );
